import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Button, FormatDate, Text } from '@reveni-io/reveni-ui'

import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import GoLiveConfirmModal from './GoLiveConfirmModal/GoLiveConfirmModal'
import useGoLive from './hooks/useGoLive'
import { merchantStatuses } from './constants'
import * as Styles from './styles'

const TrialBanner = ({ status, trialPeriodDate }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const { showConfirmModal, setShowConfirmModal, handleGoLive, loading } = useGoLive()
  const { isOwner } = useUserPermissions()

  if (status !== merchantStatuses.trial) return null

  return (
    <>
      <Styles.Container data-testid="trial-banner">
        <Text type="bodyMBold" color={theme.colors.text.inverse}>
          {t('Modo de prueba activado hasta')} <FormatDate>{trialPeriodDate}</FormatDate>.
        </Text>
        {isOwner() && (
          <Button variant="text" onClick={() => setShowConfirmModal(true)} data-testid="trial-go-live-button">
            <Text type="bodySBold" color={theme.colors.text.inverse}>
              {t('Finalizar')}
            </Text>
          </Button>
        )}
      </Styles.Container>
      {isOwner() && (
        <GoLiveConfirmModal
          show={showConfirmModal}
          onClose={() => setShowConfirmModal(false)}
          onConfirm={handleGoLive}
          loading={loading}
        />
      )}
    </>
  )
}

export default TrialBanner
